import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root' // Makes the service available app-wide
})
export class PurchaseService {
  constructor(private http: HttpClient) { }
  private apiUrl = environment.apiUrl;

  verifyPurchase(token: string): Observable<string> {
    return this.http.get(`${this.apiUrl}/Marketplace/PurchaseCallback?token=${token}`, {
      responseType: 'text'
    });
  }
}